'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/weeksBefore.js
// module id = 220
// module chunks = 0